import React, { Component } from "react";
import { withTranslate } from "react-redux-multilingual";

import { connect } from "react-redux";

import { SlideUpDown } from "../../services/script";
import { ToastContainer } from "react-toastify";

import store from "../../store";
import classes from "./theme-settings.module.scss";


class ThemeSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      divName: "RTL",
      themeLayout: false,
      themeColor: this.props.themeColor,
    };
  }

  /*=====================
     Tap on Top
     ==========================*/
  componentWillMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  // handleScroll = () => {
  //   if (document.documentElement.scrollTop > 600) {
  //     document.querySelector(".tap-top").style = "display: flex";
  //   } else {
  //     document.querySelector(".tap-top").style = "display: none";
  //   }
  // };
  clickToTop() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }

  componentDidMount() {
    SlideUpDown("setting-title");
    if (navigator.cookieEnabled) {
      if (localStorage.getItem("themeLayout") === "dark") {
        this.setState({ themeLayout: "dark" });
      } else {
        this.setState({ themeLayout: "" });
      }
    } else {
      if (this.state.themeColor === "dark") {
        this.setState({ themeLayout: "dark" });
      } else {
        this.setState({ themeLayout: "" });
      }
    }
  }

  // Color Picker
  changeColor(event, color) {
    var elems = document.querySelectorAll(".color-box li");
    [].forEach.call(elems, function (elemt) {
      elemt.classList.remove("active");
    });

    event.target.classList.add("active");
    document
      .getElementById("color")
      .setAttribute(
        "href",
        `${process.env.PUBLIC_URL}/assets/css/` + color + `.css`,
      );
  }

  ChangeRtl(divName) {
    if (divName === "RTL") {
      document.body.classList.add("rtl");
      this.setState({ divName: "LTR" });
    } else {
      document.body.classList.remove("rtl");
      this.setState({ divName: "RTL" });
    }
  }

  changeThemeLayout() {
    this.setState({
      themeLayout: !this.state.themeLayout,
    });

    if (navigator.cookieEnabled) {
      if (localStorage.getItem("themeLayout") === "dark") {
        localStorage.setItem("themeLayout", "light");
      } else {
        localStorage.setItem("themeLayout", "dark");
      }
    }
    if (this.props.themeColor === "light") {
      store.dispatch({ type: "THEME_LAYOUT", themeColor: "dark" });
    } else {
      store.dispatch({ type: "THEME_LAYOUT", themeColor: "light" });
    }
  }

  render() {
    if (navigator.cookieEnabled) {
      if (localStorage.getItem("themeLayout") === "dark") {
        document.body.classList.add("dark");
      } else {
        document.body.classList.remove("dark");
      }
    } else {
      if (this.state.themeColor === "dark") {
        document.body.classList.add("dark");
      } else {
        document.body.classList.remove("dark");
      }
    }
    // let tap_to_top = { display: "none" };

    return (
      <>
        {/*
        <div
          className={`tap-top ${classes.theme_chat_btn}`}
          onClick={this.clickToTop}
          style={{ display: "none" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M4.49414 21.1279L6.39994 20.242C10.4187 18.3739 13.4511 14.8786 14.7364 10.6332L15.4949 8.12793L16.0616 10.2089C17.2853 14.7022 20.4532 18.4115 24.6966 20.3196L26.4941 21.1279" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>
        */}

        <ToastContainer
          autoClose={3000}
          hideProgressBar
          position="bottom-center"
          className="p-0 toast-container"
          closeButton={
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M16.6055 8.3222L15.6778 7.39453L12 11.0723L8.3222 7.39453L7.39453 8.3222L11.0723 12L7.39453 15.6778L8.3222 16.6055L12 12.9277L15.6778 16.6055L16.6055 15.6778L12.9277 12L16.6055 8.3222Z"
                fill="#363636"
              />
            </svg>
          }
        />
      </>
    );
  }
}

// export default withTranslate(ThemeSettings);

const mapStateToProps = (state) => ({
  themeColor: state.theme.themeColor,
});

export default connect(mapStateToProps)(withTranslate(ThemeSettings));
